import React from 'react';

function CustomerForm({ customerInfo, onChange }) {
  return (
    <form className="customer-form" onSubmit={(e) => e.preventDefault()}>
      {/* Required Fields */}
      <div className="form-group">
        <label htmlFor="full_name">Navn:</label>
        <input type="text" id="full_name" name="full_name" value={customerInfo.full_name} onChange={onChange} required />
      </div>
      <div className="form-group">
        <label htmlFor="email">Epost:</label>
        <input type="email" id="email" name="email" value={customerInfo.email} onChange={onChange} required />
      </div>
      <div className="form-group">
        <label htmlFor="phone">Telefon:</label>
        <input type="tel" id="phone" name="phone" value={customerInfo.phone} onChange={onChange} />
      </div>

      {/* Address Fields */}
      <div className="form-group">
        <label htmlFor="company">Firma (Valgfritt):</label>
        <input type="text" id="company" name="company" value={customerInfo.company} onChange={onChange} />
      </div>
      <div className="form-group">
        <label htmlFor="address">Adresse:</label>
        <input type="text" id="address" name="address" value={customerInfo.address} onChange={onChange} />
      </div>
      <div className="form-group address-inline"> {/* Use CSS for inline layout if desired */}
          <label htmlFor="zip_code">Postnummer:</label>
          <input type="text" id="zip_code" name="zip_code" value={customerInfo.zip_code} onChange={onChange} pattern="\d{4}" title="Enter a 4-digit zip code"/> {/* Basic pattern example */}
          <label htmlFor="city">Poststed:</label>
          <input type="text" id="city" name="city" value={customerInfo.city} onChange={onChange} />
      </div>


      {/* Notes */}
      <div className="form-group">
        <label htmlFor="note">Note (Optional):</label>
        <textarea id="note" name="note" value={customerInfo.note} onChange={onChange} />
      </div>
    </form>
  );
}

export default CustomerForm;